import { SUBMIT_EMAIL_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import addToMailingList from 'root/src/client/logic/form/thunks/addToMailingList'

export default {
	[SUBMIT_EMAIL_FORM_MODULE_ID]: [
		{
			action: addToMailingList,
		},
	],
}
